import React from 'react';
import Button from 'react-bootstrap/Button';
import { IButton } from '../../types/types';
import { Colors } from '../colors/colors';




const ButtonComponent = ({
  bgColor,
  text,
  hasIcon,
  style,
  click,
  isLoading,
  cName
}: IButton) => {

  const {
    primaryColor
  } = Colors();



  return (
    <>
      <Button
        className={`btn-primary ${cName && cName}`}
        variant="primary"
        bsPrefix="btn"
        onClick={click}
        style={{
          backgroundColor: bgColor,
          border: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "15px 20px",
          color: primaryColor,
          minWidth: "48px",
          maxWidth: "162px",
          borderRadius: "40px",
          cursor: "pointer",
          fontSize: "1.2rem",
          fontFamily: "Nunito",
          fontWeight: "700",
          ...style
        }}
        disabled={isLoading}
      >
        {text} {hasIcon && hasIcon}
      </Button>
    </>
  );
}

export default ButtonComponent;